import { UserPlus, Users } from 'lucide-react';
import { useGetOne, useGetResourceLabel } from 'ra-core';
import { useParams } from 'react-router-dom';
import { UserAssignmentEmpty } from '../../User/UserAssignmentEmpty';
import { UserAssignmentList } from '../../User/UserAssignmentList';
import { BulkAddUserGroupMembers } from './BulkAddUserGroupMembers';
import { BulkRemoveUserGroupMembers } from './BulkRemoveUserGroupMembers';

type DisplayMode = 'members' | 'non-members';

export interface UserGroupMembershipListProps {
  displaying: DisplayMode;
}

export const UserGroupMembershipList = (
  props: UserGroupMembershipListProps
) => {
  const getResourceLabel = useGetResourceLabel();
  const { groupId } = useParams<{ groupId: string }>();
  const numericGroupId = Number(groupId);
  const invitingUsers = props.displaying === 'non-members';
  const filterKey = invitingUsers ? 'excludeUserGroupIds' : 'userGroupIds';
  const { data: group } = useGetOne('user-groups', { id: groupId });

  return (
    <UserAssignmentList
      key={props.displaying}
      title={[
        { label: getResourceLabel('user-groups', 2), href: '/user-groups' },
        group?.name || getResourceLabel('user-groups', 1),
        invitingUsers
          ? 'moonstar.user-group-members.add.label'
          : 'moonstar.user-group-members.title',
      ]}
      empty={
        invitingUsers ? (
          <UserAssignmentEmpty
            message="moonstar.user-group-members.allMembersAssigned"
            to={`/user-groups/${numericGroupId}/members`}
            icon={<Users />}
            label="moonstar.user-group-members.view.label"
          />
        ) : (
          <UserAssignmentEmpty
            message="moonstar.user-group-members.noMembersAssigned"
            to={`/user-groups/${numericGroupId}/members/add`}
            icon={<UserPlus />}
            label="moonstar.user-group-members.add.label"
          />
        )
      }
      filter={{ [filterKey]: [numericGroupId] }}
      bulkActionButtons={
        invitingUsers ? (
          <BulkAddUserGroupMembers groupId={numericGroupId} />
        ) : (
          <BulkRemoveUserGroupMembers groupId={numericGroupId} />
        )
      }
    />
  );
};
